export type ArticleSource = {
  title: string;
  url: string;
};

/**
 * Article-specific primary and qualifying independent sources.
 *
 * These references are intentionally separate from pillar-level background
 * reading. They make the source context of time-sensitive analyses traceable
 * to the announcement, documentation, report, or independent coverage that
 * supports the article's stated scope.
 */
const ARTICLE_SOURCE_CONTEXT: Record<string, ArticleSource[]> = {
  "chatgpt-search-20-percent-google-query-volume": [
    { title: "Big Technology: original Adam Fry interview, published November 3, 2026; company statement, incomplete accessible counting methods", url: "https://www.bigtechnology.com/p/openai-chatgpt-search-is-about-20" },
    { title: "The Verge: November 3, 2026 event reporting; secondary operational definition", url: "https://www.theverge.com/ai-artificial-intelligence/1025482/openai-says-chatgpt-is-catching-up-to-google-in-search" },
    { title: "Semrush: April 7, 2026 updated analysis; February 2026 U.S. query estimate", url: "https://www.semrush.com/blog/chatgpt-search-insights/" },
    { title: "How AI Search Rewrites the Web's Economic Bargain: working paper v1, July 8, 2026; Table 1 U.S. desktop event-specific referrals", url: "https://arxiv.org/html/2607.07652v1" },
    { title: "Google Search Console: Generative AI Search report; global availability August 31, 2026, included Google AI link impressions", url: "https://support.google.com/webmasters/answer/16984139?hl=en" },
  ],
  "expedia-ai-disintermediation-agentic-commerce-2026": [
  {
    "title": "Expedia Group Form 10-K: year ended December 31, 2025, filed February 13, 2026",
    "url": "https://www.sec.gov/Archives/edgar/data/1324424/000132442426000008/expe-20251231.htm"
  },
  {
    "title": "Expedia Group Q1 2026 results: May 7, 2026",
    "url": "https://ir.expediagroup.com/news-and-events/news/news-details/2026/Expedia-Group-Reports-First-Quarter-2026-Results/default.aspx"
  },
  {
    "title": "Uber hotel-booking announcement: April 29, 2026, initial U.S. scope",
    "url": "https://investor.uber.com/news-events/news/press-release-details/2026/Uber-Expands-into-Travel-with-Hotel-Bookings-and-New-In-App-Features/default.aspx"
  },
  {
    "title": "Expedia Group planned AI experiences: May 19, 2026",
    "url": "https://ir.expediagroup.com/news-and-events/news/news-details/2026/Expedia-Group-Unveils-New-AI-Experiences-Expands-Travel-Ecosystem-and-Launches-Philanthropy-Program-at-Explore-2026/default.aspx"
  }
],
  "nano-banana-google-search-button": [
    {
      "title": "Google: How to edit images with Nano Banana in Search",
      "url": "https://blog.google/products-and-platforms/products/search/nano-banana-search-lens/"
    },
    {
      "title": "Google: Introducing Nano Banana Pro",
      "url": "https://blog.google/innovation-and-ai/products/nano-banana-pro/"
    },
    {
      "title": "Google: Introducing Nano Banana 2",
      "url": "https://blog.google/innovation-and-ai/technology/ai/nano-banana-2/"
    },
    {
      "title": "Google AI for Developers: Nano Banana image generation",
      "url": "https://ai.google.dev/gemini-api/docs/image-generation"
    },
    {
      "title": "Gemini: Image generation and editing",
      "url": "https://gemini.google/overview/image-generation/"
    },
    {
      "title": "Google Search Help: Create and edit images in Search",
      "url": "https://support.google.com/websearch/answer/16649374?hl=en"
    },
    {
      "title": "Google Lens: Search what you see",
      "url": "https://search.google/ways-to-search/lens/"
    },
    {
      "title": "Google Search Central: AI features and your website",
      "url": "https://developers.google.com/search/docs/appearance/ai-features"
    },
    {
      "title": "Google Search Central: Optimizing for generative AI features",
      "url": "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide"
    },
    {
      "title": "Google: Seven Nano Banana Pro prompting tips",
      "url": "https://blog.google/products-and-platforms/products/gemini/prompting-tips-nano-banana-pro/"
    },
    {
      "title": "Google Search Central: Image SEO best practices",
      "url": "https://developers.google.com/search/docs/appearance/google-images"
    },
    {
      "title": "Google Merchant Center: Image link requirements",
      "url": "https://support.google.com/merchants/answer/6324350?hl=en"
    },
    {
      "title": "Search Console: Generative AI performance report",
      "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
    },
    {
      "title": "Google Search Console: Search generative AI control",
      "url": "https://support.google.com/webmasters/answer/16908024?hl=en"
    },
    {
      "title": "Google AI for Developers: Gemini Nano Banana 2.1 model",
      "url": "https://ai.google.dev/gemini-api/docs/models/gemini-nano-banana-2.1"
    }
  ],
"openai-anthropic-new-model-clues-business-evaluation": [
  {
    "title": "GPT-6.2 Astra appears in Codex usage ahead of possible launch",
    "url": "https://www.testingcatalog.com/gpt-6-2-astra-appears-codex-usage/"
  },
  {
    "title": "Anthropic prepares to release Claude Mythos 5.5 model",
    "url": "https://www.testingcatalog.com/anthropic-prepares-to-release-claude-mythos-5-5-model/"
  },
  {
    "title": "Anthropic prepares to release Claude Fable 5.5 next week",
    "url": "https://www.testingcatalog.com/anthropic-several-models-coming-fable-5-5-reaches-partners/"
  },
  {
    "title": "Models — OpenAI API",
    "url": "https://developers.openai.com/api/docs/models"
  },
  {
    "title": "Changelog — OpenAI API",
    "url": "https://developers.openai.com/api/docs/changelog"
  },
  {
    "title": "OpenAI product release notes",
    "url": "https://openai.com/products/release-notes/"
  },
  {
    "title": "Models overview — Claude Platform Docs",
    "url": "https://platform.claude.com/docs/en/about-claude/models/overview"
  },
  {
    "title": "Claude Platform release notes",
    "url": "https://platform.claude.com/docs/en/release-notes/overview"
  },
  {
    "title": "Anthropic News",
    "url": "https://www.anthropic.com/news"
  },
  {
    "title": "Claude Mythos 5.1",
    "url": "https://www.anthropic.com/claude/mythos"
  },
  {
    "title": "Claude Fable 5.1 and Mythos 5.1",
    "url": "https://www.anthropic.com/claude-fable-and-mythos-5-1"
  },
  {
    "title": "Lumina public Codex usage screenshot post",
    "url": "https://x.com/LuminaBench/status/2116848563405644250"
  },
  {
    "title": "TestingCatalog public Mythos reference screenshot post",
    "url": "https://x.com/testingcatalog/status/2116915996850074008"
  }
],
"ai-search-follow-up-questions-content-ownership": [
  {
    "title": "Every AI follow-up question is another SEO opportunity",
    "url": "https://searchengineland.com/ai-follow-up-question-seo-opportunity-499649"
  },
  {
    "title": "AI in Search: Going beyond information to intelligence",
    "url": "https://blog.google/products-and-platforms/products/search/google-search-ai-mode-update/"
  },
  {
    "title": "Get AI-powered responses with AI Mode in Google Search",
    "url": "https://support.google.com/websearch/answer/16011537?hl=en&co=GENIE.Platform%3DAndroid"
  },
  {
    "title": "7 Common HubSpot Salesforce Integration Issues",
    "url": "https://marcloudconsulting.com/development/hubspot-salesforce-integration-issues/"
  },
  {
    "title": "Salesforce to HubSpot Migration Cost: What to Budget in 2026",
    "url": "https://elefanterevops.com/blog/salesforce-to-hubspot-migration-cost"
  },
  {
    "title": "Connect HubSpot and Salesforce",
    "url": "https://knowledge.hubspot.com/salesforce/install-the-hubspot-salesforce-integration"
  },
  {
    "title": "What is canonicalization",
    "url": "https://developers.google.com/search/docs/crawling-indexing/canonicalization"
  },
  {
    "title": "AI features and your website",
    "url": "https://developers.google.com/search/docs/appearance/ai-features"
  }
],
"indiamart-agentic-ai-b2b-qualification-measurement": [
  {
    "title": "From Search to Decision: How IndiaMART Is Scaling Agentic AI for B2B Commerce",
    "url": "https://www.cio.com/article/4243169/from-search-to-decision-how-indiamart-is-scaling-agentic-ai-for-b2b-commerce.html"
  },
  {
    "title": "IndiaMART Q1 FY27 Earnings Presentation",
    "url": "https://investor.indiamart.com/files/IndiaMART_Q1FY27_Earnings_Presentation_Final.pdf"
  },
  {
    "title": "IndiaMART InterMESH Limited releases Q2FY27 results",
    "url": "https://corporate.indiamart.com/2026/10/27/indiamart-intermesh-limited-releases-q2fy27-results-reports-consolidated-revenue-rs-429-crore-representing-a-growth-of-10/"
  },
  {
    "title": "IndiaMART and SquadStack.ai Deploy India’s Largest Agentic AI System – VANI",
    "url": "https://corporate.indiamart.com/2026/06/17/indiamart-and-squadstack-ai-deploy-indias-largest-agentic-ai-system-vani/"
  },
  {
    "title": "The I in CIO is moving from Information to Intelligence and Innovation – Nikhil Prabhakar, IndiaMART",
    "url": "https://corporate.indiamart.com/2026/06/03/the-i-in-cio-is-moving-from-information-to-intelligence-and-innovation-nikhil-prabhakar-indiamart/"
  }
],
"ai-productivity-workflow-verification-costs": [
  {
    "title": "ActivTrak Productivity Lab: AI Users’ Work Days Are Up To 90 Minutes Longer Than Non-Users",
    "url": "https://www.activtrak.com/blog/productivity-lab-ai-users-longer-workdays/"
  },
  {
    "title": "Does AI actually save employees time? Data is contradictory",
    "url": "https://www.cio.com/article/4243615/does-ai-actually-save-employees-time-data-is-contradictory.html"
  },
  {
    "title": "ActivTrak Productivity Lab: AI Users Have Workdays Up to 90 Minutes Longer Than Non-Users",
    "url": "https://www.activtrak.com/news/productivity-lab-ai-users-longer-workdays/"
  },
  {
    "title": "2026 State of the Workplace: AI Adoption & Workforce Performance Benchmarks",
    "url": "https://www.activtrak.com/resources/state-of-the-workplace/"
  },
  {
    "title": "ActivTrak Productivity Lab: AI Is Accelerating Work, Not Replacing It",
    "url": "https://www.activtrak.com/news/state-of-the-workplace-ai-accelerating-work/"
  }
],
"ai-answer-verification-website-evidence": [
  {
    "title": "The quiet click: Why people read AI answers and click anyway",
    "url": "https://searchengineland.com/why-people-read-click-ai-answers-499684"
  },
  {
    "title": "Protected: The Quiet Click: What Today’s Consumers Really Want From Search Results",
    "url": "https://www.frac.tl/the-quiet-click/"
  },
  {
    "title": "Google users are less likely to click on links when an AI summary appears in the results",
    "url": "https://www.pewresearch.org/short-reads/2025/07/22/google-users-are-less-likely-to-click-on-links-when-an-ai-summary-appears-in-the-results/"
  },
  {
    "title": "Top ways to ensure your content performs well in Google's AI experiences on Search",
    "url": "https://developers.google.com/search/blog/2025/05/succeeding-in-ai-search"
  }
],
"chatgpt-ads-google-search-revenue-study-test-decision": [
  {
    "title": "Can Advertising Fund Free AI? Evidence from ChatGPT's International Advertising Rollout",
    "url": "https://ecommerceresearch.org/chatgpt-ads/"
  },
  {
    "title": "Complete working paper and Web Appendix",
    "url": "https://ecommerceresearch.org/chatgpt-ads/Kaiser-Schulze-2026-Can-Advertising-Fund-Free-AI.md"
  },
  {
    "title": "ChatGPT ads generate 64% less revenue per visit than Google Search: Study",
    "url": "https://searchengineland.com/chatgpt-ads-generate-less-revenue-per-visit-than-google-search-study-500160"
  },
  {
    "title": "Google Search Ad Visits Out-Earned ChatGPT Ads In U.S.",
    "url": "https://www.searchenginejournal.com/google-search-chatgpt-ad-revenue-per-visit/595596/"
  },
  {
    "title": "ChatGPT Ads Benchmarks: ROAS, CPC, and Cost From 15 Days of Real Spend",
    "url": "https://opascope.com/insights/chatgpt-ads-benchmarks/"
  },
  {
    "title": "Frequently asked questions",
    "url": "https://help.openai.com/en/articles/20001220-frequently-asked-questions"
  },
  {
    "title": "Ads in ChatGPT: The Basics",
    "url": "https://help.openai.com/en/articles/20001207-ads-in-chatgpt-the-basics"
  }
],
"grok-bot-costs-usage-limits-api-budgeting": [
  {
    "title": "Musk Says Grok Bot’s Costs Were ‘Unsustainably High’ Weeks After Touting Rapid Growth",
    "url": "https://www.forbes.com/sites/siladityaray/2026/11/02/musk-says-grok-bots-costs-were-unsustainably-high-weeks-after-touting-rapid-growth/"
  },
  {
    "title": "Elon Musk reply on the cost of serving Grok Bot",
    "url": "https://x.com/elonmusk/status/2116992258520064397"
  },
  {
    "title": "Doge Norway asks for a Grok Bot usage reset",
    "url": "https://x.com/DogecoinNorway/status/2116986414110007446"
  },
  {
    "title": "Meet Grok Bot",
    "url": "https://x.ai/bot"
  },
  {
    "title": "Pricing: Compare Plans",
    "url": "https://x.ai/pricing"
  },
  {
    "title": "Usage limits",
    "url": "https://docs.x.ai/x-subscription/usage-limits"
  },
  {
    "title": "What is The X Subscription?",
    "url": "https://docs.x.ai/x-subscription/overview"
  },
  {
    "title": "Spending caps: monthly extra-usage caps and alerts",
    "url": "https://docs.x.ai/x-subscription/spending-caps"
  },
  {
    "title": "API Pricing",
    "url": "https://docs.x.ai/developers/pricing"
  },
  {
    "title": "Grok 4.7 model details",
    "url": "https://docs.x.ai/developers/models/grok-4.7"
  },
  {
    "title": "Rate Limits",
    "url": "https://docs.x.ai/developers/rate-limits"
  },
  {
    "title": "Cost Tracking",
    "url": "https://docs.x.ai/developers/cost-tracking"
  },
  {
    "title": "Reasoning",
    "url": "https://docs.x.ai/developers/model-capabilities/text/reasoning"
  }
],
"ai-api-budget-worksheet-estimate-reconcile": [
  {
    "title": "Prompt caching | OpenAI API",
    "url": "https://developers.openai.com/api/docs/guides/prompt-caching"
  },
  {
    "title": "Batch API | OpenAI API",
    "url": "https://developers.openai.com/api/docs/guides/batch"
  },
  {
    "title": "Spend limits | OpenAI API",
    "url": "https://developers.openai.com/api/docs/guides/spend-limits"
  },
  {
    "title": "Reviewing API usage and costs | OpenAI Help Center",
    "url": "https://help.openai.com/en/articles/10478918-reviewing-api-usage-and-costs"
  },
  {
    "title": "Exporting monthly usage details from the API Usage Dashboard | OpenAI Help Center",
    "url": "https://help.openai.com/en/articles/20001072-exporting-monthly-usage-details-from-the-api-usage-dashboard"
  }
],
"write-content-cited-chatgpt-answers": [
  {
    "title": "Google: Optimizing your website for generative AI features on Google Search",
    "url": "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide"
  },
  {
    "title": "Google: Creating helpful, reliable, people-first content",
    "url": "https://developers.google.com/search/docs/fundamentals/creating-helpful-content"
  },
  {
    "title": "Google Search documentation updates: June 2026 FAQ rich-result removal",
    "url": "https://developers.google.com/search/updates"
  },
  {
    "title": "OpenAI: Overview of OpenAI crawlers",
    "url": "https://developers.openai.com/api/docs/bots"
  },
  {
    "title": "Google Search Console: Generative AI performance report for Search",
    "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
  }
],

  "demandbase-b2a-aeo-buying-committees-2026": [
    {
      title: "Demandbase: New AI Agents for the B2A Marketing Era",
      url: "https://www.demandbase.com/press-release/b2a-ai-agents/",
    },
    {
      title: "Gartner: Top Predictions for IT Organizations and Users in 2026 and Beyond",
      url: "https://www.gartner.com/en/newsroom/press-releases/2025-10-21-gartner-unveils-top-predictions-for-it-organizations-and-users-in-2026-and-beyond",
    },
  ],
  "humain-nvidia-84mw-ai-compute-plan-saudi-arabia-2026": [
    {
      title: "HUMAIN: 84 MW NVIDIA AI compute infrastructure plan announcement",
      url: "https://x.com/HUMAIN/status/2113163482447204542",
    },
    {
      title: "The National: Humain expands Nvidia deal with 84 MW AI computing plan",
      url: "https://www.thenationalnews.com/future/technology/2026/10/22/saudi-arabias-humain-expands-nvidia-deal-with-84mw-ai-computing-plan/",
    },
  ],
  "how-to-choose-ai-search-aeo-agency-b2b-2026": [
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/appearance/ai-features" },
    { title: "Google Search Central: General structured data guidelines", url: "https://developers.google.com/search/docs/appearance/structured-data/sd-policies" },
    { title: "Google Search Central: Creating helpful, reliable, people-first content", url: "https://developers.google.com/search/docs/fundamentals/creating-helpful-content" },
    { title: "Google Search guidance on third-party SEO services and advice", url: "https://developers.google.com/search/docs/fundamentals/third-party-seo" },
  ],
  "sabi-brain-ai-cap-neural-data-consent-governance-2026": [
    { title: "Sabi funding announcement: $50M seed round for a proposed brain-AI cap", url: "https://www.globenewswire.com/news-release/2026/10/09/3378310/0/en/sabi-raises-50-million-seed-round-led-by-khosla-ventures-to-put-a-brain-ai-interface-inside-a-baseball-cap.html" },
    { title: "Forbes: reporting on Sabi’s nascent prototype and founder-attributed laboratory claim", url: "https://www.forbes.com/sites/rashishrivastava/2026/10/09/vinod-khosla-backs-an-ai-startup-building-a-mind-reading-baseball-cap/" },
    { title: "Peer-reviewed review: EEG-based imagined-speech decoding", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC9086783/" },
    { title: "Peer-reviewed review: advances and challenges in speech-imagery BCI", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC12453656/" },
    { title: "UNESCO Recommendation on the Ethics of Neurotechnology", url: "https://www.unesco.org/en/legal-affairs/recommendation-ethics-neurotechnology" },
    { title: "Colorado General Assembly: HB24-1058 neural-data privacy law", url: "https://leg.colorado.gov/bills/hb24-1058" },
  ],
  "ios-272-beta-4-siri-ai-features-2026": [
    { title: "Apple Developer: iOS and iPadOS 27.2 Beta 4 release notes", url: "https://developer.apple.com/documentation/ios-ipados-release-notes/ios-ipados-27_2-release-notes" },
    { title: "Apple Developer: Get ready with the latest beta releases", url: "https://developer.apple.com/news/?id=rfb1rooi" },
    { title: "Apple Support: About iOS 27 Updates", url: "https://support.apple.com/en-us/149076" },
    { title: "Apple Support: Siri AI availability and requirements", url: "https://support.apple.com/en-us/127893" },
    { title: "Apple Developer: alternative ATT consent flow in Europe", url: "https://developer.apple.com/news/?id=idsft9ai" },
    { title: "9to5Mac: Apple releases iOS 27.2 RC for iPhone", url: "https://9to5mac.com/2026/10/19/apple-releases-ios-27-2-rc-for-iphone/" },
    { title: "MacRumors: Apple Releases iOS 27.2 Release Candidate", url: "https://www.macrumors.com/2026/10/19/apple-releases-ios-27-2-rc/" },
    { title: "9to5Mac: late iOS 27.2 beta changes", url: "https://9to5mac.com/2026/10/16/ios-27-2-has-three-new-changes-just-added-this-week/" },
  ],
  "tesla-flying-roadster-spacex-merger-2026": [
    { title: "Tesla: Roadster product and reservation information", url: "https://www.tesla.com/roadster/reserve" },
    { title: "Tesla Investor Relations: Q3 2026 production, deliveries and deployments", url: "https://ir.tesla.com/press-release/tesla-third-quarter-2026-production-deliveries-and-deployments" },
    { title: "Reuters: Tesla Roadster unveil and 2028 target", url: "https://www.reuters.com/business/autos-transportation/tesla-set-unveil-next-generation-roadster-sports-ev-after-years-delay-2026-10-15/" },
    { title: "Associated Press: Roadster prototype manoeuvres and market reaction", url: "https://apnews.com/article/7d5f19665435b7408025bfb7a2f2f0b7" },
    { title: "CNBC: Tesla Roadster reveal coverage", url: "https://www.cnbc.com/2026/10/15/tesla-roadster-reveal-what-to-know-about-the-delayed-ev.html" },
    { title: "Reuters syndicated by Investing.com: 16 October market snapshot", url: "https://www.investing.com/news/economy-news/wall-st-futures-mixed-as-tech-wobbles-again-tesla-gains-4953758" },
    { title: "Yahoo Finance: Barclays SpaceX-Tesla scenario coverage", url: "https://finance.yahoo.com/markets/stocks/article/will-spacex-merge-with-tesla-speculation-resurfaces-it-could-happen-before-the-end-of-2026-162443386.html" },
    { title: "Nasdaq: TSLA quotation", url: "https://www.nasdaq.com/market-activity/stocks/tsla" },
    { title: "Yahoo Finance: TSLA historical chart data", url: "https://finance.yahoo.com/quote/TSLA/history/" },
    { title: "Nasdaq: SPCX quotation", url: "https://www.nasdaq.com/market-activity/stocks/spcx" },
  ],
  "refresh-repurpose-or-create-new-content-decision-guide-2026": [
    {
      title: "Marketer Magazine: Repurpose or Create New? Content Marketing Leaders Share What Drives Better Results",
      url: "https://marketermagazine.co/qa/repurpose-or-create-new-content-marketing-leaders-share-what-drives-better-results/",
    },
    {
      title: "Google Search Central: Creating helpful, reliable, people-first content",
      url: "https://developers.google.com/search/docs/fundamentals/creating-helpful-content",
    },
  ],
  "google-flow-ai-marketing-teams-aeo-2026": [
    {
      title: "Google DeepMind: Nano Banana 2.1 model card",
      url: "https://deepmind.google/models/model-cards/nano-banana-2-1/",
    },
    {
      title: "Google: Veo 3.1 updates in Flow",
      url: "https://blog.google/innovation-and-ai/products/veo-updates-flow/",
    },
    {
      title: "Google: Nano Banana 2 and SynthID Content Credentials",
      url: "https://blog.google/innovation-and-ai/technology/ai/nano-banana-2/",
    },
    {
      title: "Google Ads: Create videos from images with Veo",
      url: "https://business.google.com/en-all/accelerate/announcements/veo-google-ads/",
    },
    {
      title: "Google: Agentic commerce and checkout updates",
      url: "https://blog.google/products/ads-commerce/agentic-commerce-ai-tools-protocol-retailers-platforms/",
    },
  ],
  "ai-marketing-persona-paid-and-earned": [
    {
      title: "Google Search Central: Generative AI features and your website",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "us-china-ai-talks-superintelligence-marketing-manufacturing-jobs-2026": [
    {
      title:
        "POLITICO: U.S., Chinese visions for AI regulation differ sharply at UN meeting",
      url: "https://www.politico.com/news/2026/09/23/us-chinese-visions-for-ai-regulation-differ-sharply-at-un-meeting-01090906",
    },
    {
      title:
        "PBS NewsHour: AI, trade, Iran and Taiwan top agenda at Trump-Xi summit",
      url: "https://www.pbs.org/newshour/show/ai-trade-iran-and-taiwan-top-agenda-at-trump-xi-summit",
    },
    {
      title: "The White House: America's AI Action Plan",
      url: "https://www.whitehouse.gov/wp-content/uploads/2025/07/Americas-AI-Action-Plan.pdf",
    },
    {
      title:
        "Permanent Mission of China to the UN: Global AI Governance Action Plan",
      url: "https://un.china-mission.gov.cn/eng/zgyw/202507/t20250729_11679232.htm",
    },
    {
      title: "Stanford HAI: 2026 AI Index Report",
      url: "https://hai.stanford.edu/assets/files/ai_index_report_2026.pdf",
    },
    {
      title: "World Economic Forum: Future of Jobs Report 2025",
      url: "https://www.weforum.org/publications/the-future-of-jobs-report-2025/",
    },
    {
      title: "International Federation of Robotics: The Impact of Robots",
      url: "https://ifr.org/ifr-press-releases/news/global-robot-demand-in-factories-doubles-over-six-years",
    },
  ],
  "openai-sponsored-agents-chatgpt-ads-hubspot-shopify-2026": [
    {
      title: "OpenAI: Reimagining advertising with AI",
      url: "https://openai.com/index/reimagining-advertising-with-ai/",
    },
    {
      title: "HubSpot: Fall 2026 Spotlight",
      url: "https://www.hubspot.com/company-news/fall-26-spotlight",
    },
    {
      title: "Reuters: OpenAI tests advertiser-sponsored agents",
      url: "https://www.reuters.com/business/media-telecom/openai-tests-advertiser-sponsored-agents-expands-ai-tools-chatgpt-ads-2026-09-16/",
    },
  ],
  "google-merchant-center-ai-performance-insights-share-of-voice-2026": [
    {
      title: "Google Merchant Center Help: About AI performance insights",
      url: "https://support.google.com/merchants/answer/17200695",
    },
    {
      title: "Google: Agentic commerce updates for holiday shopping",
      url: "https://blog.google/products-and-platforms/products/shopping/google-shopping-updates-holiday-shopping/",
    },
    {
      title: "Google Merchant Center Help: Conversational attributes",
      url: "https://support.google.com/merchants/answer/17085370",
    },
  ],
  "google-business-agent-youtube-ads-ucp-2026-09-16": [
    {
      title: "Google: Agentic commerce updates for holiday shopping",
      url: "https://blog.google/products-and-platforms/products/shopping/google-shopping-updates-holiday-shopping/",
    },
    {
      title: "Google Developers: Universal Commerce Protocol on Google",
      url: "https://developers.google.com/merchant/ucp",
    },
    {
      title: "Google Merchant Center Help: UCP-powered checkout",
      url: "https://support.google.com/merchants/answer/16837055?hl=en",
    },
  ],
  "openai-model-misalignment-reporting-framework-2026-09-16": [
    {
      title: "OpenAI: Our framework for reporting model misalignment",
      url: "https://openai.com/index/model-misalignment-reporting-framework/",
    },
    {
      title: "Reuters: OpenAI to regularly disclose AI misbehavior",
      url: "https://www.reuters.com/technology/openai-releases-framework-track-model-misalignment-2026-09-16/",
    },
  ],
  "zen-media-b2b-saas-ai-visibility-documentation-2026-09-16": [
    {
      title: "Zen Media: AI Visibility for SaaS Companies benchmark",
      url: "https://ai.zenmedia.com/share/7efddb70-4d1f-4ae0-be4b-0ba64b4ac8ee",
    },
    {
      title: "GlobeNewswire: Zen Media benchmark release",
      url: "https://www.globenewswire.com/news-release/2026/09/16/3363478/0/en/ai-visibility-for-saas-companies-averages-9-across-the-top-100-vendors-zen-media-benchmark-finds.html",
    },
  ],
  "transparent-aeo-evidence-based-ai-visibility-scoring-2026": [
    {
      title: "Google Search Central: Optimizing for generative AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "Google Search Central: Introduction to structured data markup",
      url: "https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data",
    },
    {
      title: "Google Search Central: Get started with Search Console",
      url: "https://developers.google.com/search/docs/monitor-debug/search-console-start",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "ai-visibility-benchmark-2026-citation-rates-share-of-voice": [
  {
    "title": "Google Ads: Use auction insights to compare performance",
    "url": "https://support.google.com/google-ads/answer/2579754?hl=en"
  },
  {
    "title": "OpenAI: Searching the web with ChatGPT",
    "url": "https://help.openai.com/en/articles/9237897-searching-the-web-with-chatgpt"
  },
  {
    "title": "Google Search Central: AI features and your website",
    "url": "https://developers.google.com/search/docs/appearance/ai-features"
  },
  {
    "title": "Google Search Console: Generative AI performance report for Search",
    "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
  },
  {
    "title": "Google Search Central: Introducing Search Generative AI performance reports",
    "url": "https://developers.google.com/search/blog/2026/06/gen-ai-performance-reports"
  }
],
  "gemini-connected-apps-saas-interface-2026": [
    {
      title: "Google: New Connected Apps roll out to Gemini",
      url: "https://blog.google/innovation-and-ai/products/gemini-app/new-connected-apps-gemini/",
    },
    {
      title:
        "Google Workspace Admin Help: Gemini app and external app connections",
      url: "https://support.google.com/a/answer/16715849",
    },
  ],
  "accenture-within-enterprise-ai-value-gap-2026": [
    {
      title: "Accenture: Investment and partnership with Within",
      url: "https://newsroom.accenture.com/news/2026/accenture-and-within-help-clients-accelerate-ai-across-the-enterprise-through-strategic-investment-and-new-partnership",
    },
    {
      title: "Accenture: Pulse of Change research",
      url: "https://www.accenture.com/us-en/insights/consulting/pulse-of-change",
    },
  ],
  "collibra-agent-contracts-machine-readable-governance-2026": [
    {
      title: "Collibra: Agent Contracts and Guardian Agents announcement",
      url: "https://www.collibra.com/company/newsroom/press-releases/collibra-launches-new-capabilities-to-reduce-the-hallucination-tax-on-enterprise-ai",
    },
    {
      title: "PR Newswire: Collibra release coverage",
      url: "https://www.prnewswire.com/news-releases/collibra-launches-new-capabilities-to-reduce-the-hallucination-tax-on-enterprise-ai-302886404.html",
    },
  ],
  "google-ai-contribution-publisher-payment-pilot-2026": [
    {
      title: "Google Search Central: Optimizing for generative AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "Semrush: Google AI Contribution pilot reporting",
      url: "https://www.semrush.com/blog/google-launches-ai-contribution-pilot/",
    },
  ],
  "openai-gpt-6-sol-luna-cache-aware-agent-economics-2026": [
    {
      title: "OpenAI: Introducing GPT-6 Sol and Luna",
      url: "https://openai.com/index/introducing-gpt-6-sol-and-luna/",
    },
    {
      title: "OpenAI: Better prompt caching for GPT-6",
      url: "https://openai.com/index/better-prompt-caching-for-gpt-6/",
    },
  ],
  "blueprint-alliance-enterprise-agent-governance-stack-2026": [
    {
      title: "Forkast: Blueprint Alliance reference architecture coverage",
      url: "https://forkast.news/the-blueprint-alliance-building-an-agent-governance-stack-by-consensus/",
    },
    {
      title: "Akamai: Behavioral governance for agentic AI research",
      url: "https://www.ir.akamai.com/news-releases/news-release-details/akamai-report-securing-agentic-ai-requires-shift-behavioral",
    },
  ],
  "agentic-ai-content-workflow-global-brands": [
    {
      title: "NIST: Generative AI Profile (AI 600-1)",
      url: "https://nvlpubs.nist.gov/nistpubs/ai/NIST.AI.600-1.pdf",
    },
    {
      title: "Google Cloud: Grounding overview",
      url: "https://cloud.google.com/vertex-ai/generative-ai/docs/grounding/overview",
    },
    {
      title: "ICO: AI and data protection guidance",
      url: "https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/artificial-intelligence/",
    },
  ],
  "human-in-the-loop-ai-content-governance": [
    {
      title: "NCSC: Thinking carefully before adopting agentic AI",
      url: "https://www.ncsc.gov.uk/blogs/thinking-carefully-before-adopting-agentic-ai",
    },
    {
      title: "European Commission: AI Act transparency obligations",
      url: "https://digital-strategy.ec.europa.eu/en/policies/guidelines-ai-transparency-obligations",
    },
    {
      title: "ASA: CAP Code, misleading advertising",
      url: "https://www.asa.org.uk/type/non_broadcast/code_section/03.html",
    },
  ],
  "technical-seo-ai-search-search-console": [
    {
      title: "Google Search Central: Generative AI features guidance",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "Google Search Central: Consolidate duplicate URLs",
      url: "https://developers.google.com/search/docs/crawling-indexing/consolidate-duplicate-urls",
    },
    {
      title: "Google: Generative AI performance report",
      url: "https://support.google.com/webmasters/answer/16984139?hl=en",
    },
  ],
  "voice-visual-search-agentic-commerce": [
    {
      title: "Google Search Central: Product structured data",
      url: "https://developers.google.com/search/docs/appearance/structured-data/product",
    },
    {
      title: "OpenAI: Agentic Commerce product feed specification",
      url: "https://developers.openai.com/commerce/specs/file-upload/products",
    },
    {
      title: "CMA: Agentic AI and consumers",
      url: "https://www.gov.uk/government/publications/agentic-ai-and-consumers/agentic-ai-and-consumers",
    },
  ],
  "organic-paid-agentic-ai-cpa-ltv": [
    {
      title: "Google Search Central: Search Console and Analytics data",
      url: "https://developers.google.com/search/docs/monitor-debug/google-analytics-search-console",
    },
    {
      title: "Google Ads: User-based Conversion Lift",
      url: "https://support.google.com/google-ads/answer/12005564?hl=en",
    },
    {
      title: "ICO: Automated decision making and profiling rights",
      url: "https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/individual-rights/individual-rights/rights-related-to-automated-decision-making-including-profiling/",
    },
  ],
  "zero-click-commerce-google-ai-mode-checkout-2026": [
    {
      title:
        "TechCrunch: Google tests buying from Flipkart through Gemini and AI Mode",
      url: "https://techcrunch.com/2026/09/26/google-tests-buying-from-walmart-owned-flipkart-through-gemini-and-ai-mode-in-india/",
    },
    {
      title: "Google for Developers: Universal Commerce Protocol",
      url: "https://developers.google.com/merchant/ucp",
    },
    {
      title: "Google Search Central: Product structured data",
      url: "https://developers.google.com/search/docs/appearance/structured-data/product",
    },
  ],
  "ai-agent-landing-page-conversion-layer-2026": [
    {
      title:
        "Vietnam Investment Review: AI agents reshape Vietnam's social-commerce landscape",
      url: "https://vir.com.vn/ai-agents-reshape-vietnams-social-commerce-landscape-161710.html",
    },
    {
      title: "Meta: Introducing Meta Business Agent",
      url: "https://about.fb.com/news/2026/06/meta-business-agent/",
    },
  ],
  "human-in-the-loop-wrong-way-to-govern-ai-agents-2026": [
    {
      title: "OpenAI: Hugging Face incident and misalignment update",
      url: "https://openai.com/hugging-face-incident-and-misalignment/",
    },
    {
      title: "TechCrunch: OpenAI agents posted 53 user images",
      url: "https://techcrunch.com/2026/09/25/unsecured-openai-agents-posted-53-user-images-on-the-internet-without-the-labs-knowledge/",
    },
    {
      title: "Fortune: OpenAI rogue-agent incident follow-up",
      url: "https://fortune.com/2026/09/25/openai-rogue-agents-images-sam-altman-chatgpt-users-links-encoded-info-hugging-face-hack/",
    },
  ],
  "openai-gpt-6-1-astra-safety-governance-2026": [
    {
      title:
        "Reuters: OpenAI shelves new AI model release over safety concerns",
      url: "https://www.reuters.com/business/openai-shelves-new-ai-model-after-internal-safety-tests-wsj-reports-2026-09-28/",
    },
    {
      title:
        "OpenAI Alignment Research: An agent used DNS to reach an external chatbot",
      url: "https://alignment.openai.com/misalignment-reports/an-agent-used-dns-to-reach-an-external-chatbot/",
    },
    {
      title: "OpenAI: Our framework for reporting model misalignment",
      url: "https://openai.com/index/model-misalignment-reporting-framework/",
    },
    {
      title:
        "OpenAI: Path to Astra: critical capabilities and frontier safeguards",
      url: "https://openai.com/index/path-to-astra/",
    },
    {
      title:
        "BBC News: OpenAI scraps rollout of new model over safety concerns",
      url: "https://www.bbc.com/news/articles/cm5y5nynl75ko",
    },
  ],
  "buyer-agent-merchant-agent-ecommerce-2026": [
    {
      title: "Amazon: Seller Assistant plugin for Quick and Claude",
      url: "https://www.aboutamazon.com/news/innovation-at-amazon/seller-assistant-plugin-amazon-quick-claude",
    },
    {
      title: "Amazon Seller Central: Selling Partner plugin for AI assistants",
      url: "https://sellercentral.amazon.com/help/hub/reference/external/GAFFEKSK9UR4MGTF",
    },
  ],
  "will-ai-kill-saas-or-the-interface-2026": [
    {
      title:
        "Fortune: Bryan Goode on SaaS as an operating system for AI agents",
      url: "https://fortune.com/2026/09/26/agentic-ai-saas-human-middleware-microsoft/",
    },
    {
      title: "Microsoft Dynamics 365 Blog: Bryan Goode",
      url: "https://www.microsoft.com/en-us/dynamics-365/blog/author/bryan-goode/",
    },
  ],
  "openai-70bn-revenue-run-rate-ipo-economics-2026": [
    {
      title:
        "Reuters: OpenAI's annualized recurring revenue nears $70 billion, source says",
      url: "https://www.reuters.com/technology/openais-annual-recurring-revenue-nears-70-billion-axios-reports-2026-09-29/",
    },
    {
      title: "OpenAI: A business that scales with the value of intelligence",
      url: "https://openai.com/index/a-business-that-scales-with-the-value-of-intelligence/",
    },
    {
      title:
        "OpenAI: OpenAI raises $122 billion to accelerate the next phase of AI",
      url: "https://openai.com/index/accelerating-the-next-phase-ai/",
    },
    {
      title:
        "Reuters: OpenAI mulls funding round at $1.2 trillion valuation ahead of IPO, FT reports",
      url: "https://www.reuters.com/legal/transactional/openai-mulls-funding-round-12-trillion-valuation-ahead-ipo-ft-reports-2026-09-15/",
    },
    {
      title:
        "Bloomberg: OpenAI targets $30 billion in new funding at $1.4 trillion value",
      url: "https://www.bloomberg.com/news/articles/2026-09-29/openai-targets-30-billion-in-new-funding-at-1-4-trillion-value",
    },
    {
      title:
        "Reuters: OpenAI forecasts cash burn near $280 billion by 2030, FT reports",
      url: "https://www.reuters.com/technology/openai-expects-burn-through-almost-280-billion-by-2030-ft-reports-2026-09-18/",
    },
  ],
  "instinct-personal-agent-trust-alignment-2026": [
    {
      title:
        "Reuters: AI agent firm Instinct raises $1 billion in latest funding round",
      url: "https://www.reuters.com/technology/ai-agent-firm-instinct-raises-1-billion-latest-funding-round-2026-09-28/",
    },
    {
      title:
        "TechCrunch: Viral AI agent Instinct raises $1B Series C at a $10B valuation",
      url: "https://techcrunch.com/2026/09/28/viral-ai-agent-instinct-raises-1b-series-c-at-a-10b-valuation/",
    },
    {
      title: "Instinct: Privacy Policy",
      url: "https://instinct.com/privacy-policy",
    },
    {
      title:
        "TechCrunch: Instinct founder says more than 50% of transactions are travel-related",
      url: "https://techcrunch.com/2026/09/29/instinct-founder-said-more-than-50-of-transactions-on-the-platform-are-travel-related/",
    },
    {
      title:
        "Business Insider: Instinct founder responds to apparent data-leak claim",
      url: "https://www.businessinsider.com/instinct-founder-noah-shinn-ai-agent-hallucinate-stranger-data-leak-2026-9",
    },
    {
      title: "Meta: Introducing Muse, a personal AI agent",
      url: "https://about.fb.com/news/2026/09/introducing-muse-personal-ai-agent/",
    },
    {
      title: "OpenAI: Introducing ChatGPT agent",
      url: "https://openai.com/index/introducing-chatgpt-agent/",
    },
  ],
  "cue-by-manus-personal-agent-team-governance-2026": [
    {
      title: "Manus: Introducing Manus 2.0",
      url: "https://manus.im/blog/introducing-manus-2-0",
    },
    {
      title: "Manus Help Center: What is new in Manus 2.0?",
      url: "https://help.manus.im/en/articles/17190150-what-is-new-in-manus-2-0",
    },
    {
      title:
        "The Next Web: Manus 2.0 and Cue give AI agents their own email, phone and wallet",
      url: "https://thenextweb.com/news/manus-2-0-cue-ai-agents-email-phone-wallet",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "america-gov-phase-1-launch-gemini-and-phase-2": [
    {
      title:
        "White House: Streamlining Access to Government Services Through America.gov",
      url: "https://www.whitehouse.gov/presidential-actions/2026/09/streamlining-access-to-government-services-through-america-gov/",
    },
    {
      title: "White House fact sheet: America.gov",
      url: "https://www.whitehouse.gov/fact-sheets/2026/09/fact-sheet-president-donald-j-trump-streamlines-access-to-government-services-through-america-gov/",
    },
    {
      title: "America.gov: About Phase 1 and Phase 2",
      url: "https://america.gov/about",
    },
    {
      title: "GSA: America.gov launch release",
      url: "https://www.gsa.gov/about-gsa/newsroom/news-releases/gsa-joins-the-white-houses-national-design-studio-in-unveiling-americagov-09292026",
    },
    {
      title: "Google Public Sector: America.gov technology partnership",
      url: "https://blog.google/company-news/outreach-and-initiatives/public-policy/america-gov-google-public-sector/",
    },
    {
      title: "America.gov homepage",
      url: "https://america.gov/",
    },
    {
      title: "xAI: xAI for Government",
      url: "https://x.ai/news/government",
    },
  ],
  "what-is-superintelligence-ai-agi-asi-marketing-2026": [
    {
      title: "Google DeepMind: From AGI to ASI",
      url: "https://deepmind.google/research/publications/239142/",
    },
    {
      title: "OpenAI Charter",
      url: "https://openai.com/charter/",
    },
    {
      title: "Stanford HAI: 2026 AI Index Report",
      url: "https://hai.stanford.edu/ai-index/2026-ai-index-report",
    },
    {
      title:
        "Anthropic Alignment Science: AI Organizations Can Be More Effective but Less Aligned than Individual Agents",
      url: "https://alignment.anthropic.com/2026/ai-organizations/",
    },
  ],
  "gemini-4-argon-frontier-model-cybersecurity-governance-2026": [
    {
      title: "Google: Gemini 4 Argon: our next era of frontier intelligence",
      url: "https://blog.google/innovation-and-ai/models-and-research/gemini-models/gemini-4-argon/",
    },
    {
      title: "Google DeepMind: Fairwind Program",
      url: "https://deepmind.google/fairwind-program/",
    },
    {
      title:
        "CNBC: Google rolls out Gemini 4 Argon, its most advanced AI model",
      url: "https://www.cnbc.com/2026/09/30/google-gemini-4-argon-ai.html",
    },
    {
      title:
        "TechCrunch: Google releases Gemini 4 Argon, called its most powerful model yet",
      url: "https://techcrunch.com/2026/09/30/google-releases-gemini-4-argon-called-its-most-powerful-model-yet/",
    },
  ],
  "uk-b2b-ai-marketing-one-persona-plan-paid-search-seo-2026": [
    {
      title: "Google Search Central: Optimizing for AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "saas-brand-visibility-ai-answers-90-day-practical-stages": [
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title: "Google Search Central: Optimizing for AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "governed-ai-lead-generation-workflow-human-approval-2026": [
    {
      title: "ICO: Artificial intelligence guidance",
      url: "https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/artificial-intelligence/",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
    {
      title: "NIST: Generative AI Profile",
      url: "https://www.nist.gov/itl/ai-risk-management-framework/ai-rmf-generative-artificial-intelligence-profile",
    },
  ],
  "seo-ai-driven-search-one-useful-definition-2026": [
    {
      title: "Google Search Central: Optimizing for AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title: "Google Search Central: Introduction to structured data markup",
      url: "https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data",
    },
  ],

  "google-ai-mode-monitoring-latent-agentic-demand": [
    {
      title:
        "Search Engine Journal: Google rolls out AI Mode information monitoring worldwide",
      url: "https://www.searchenginejournal.com/google-ai-mode-info-monitoring-global-rollout/591312/",
    },
    {
      title: "Google Search: AI Mode",
      url: "https://blog.google/products/search/ai-mode-search/",
    },
    {
      title: "Google Search Central: Optimizing for AI features",
      url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide",
    },
  ],
  "chatgpt-virtual-try-on-favorites-ai-consideration": [
    {
      title: "OpenAI Help Centre: ChatGPT release notes",
      url: "https://help.openai.com/en/articles/6825453-chatgpt-release-notes",
    },
    {
      title: "TechCrunch: ChatGPT can now virtually try on clothes",
      url: "https://techcrunch.com/2026/10/01/chatgpt-can-now-virtually-try-on-clothes-for-you/",
    },
    {
      title: "Google Search Central: Product structured data",
      url: "https://developers.google.com/search/docs/appearance/structured-data/product",
    },
  ],
  "ftc-openai-anthropic-agent-accountability": [
    {
      title:
        "Associated Press: FTC investigation involving OpenAI, Anthropic and other AI companies",
      url: "https://apnews.com/article/ftc-ai-investigation-anthropic-openai-89ac416717adbfb1d72f2d85e6ce83d1",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
    {
      title: "OpenAI: Our framework for reporting model misalignment",
      url: "https://openai.com/index/model-misalignment-reporting-framework/",
    },
  ],
  "us-september-2026-payrolls-ai-finance-jobs": [
    {
      title:
        "US Bureau of Labor Statistics: The Employment Situation, September 2026",
      url: "https://www.bls.gov/news.release/empsit.nr0.htm",
    },
    {
      title: "US Bureau of Labor Statistics: Summary Table B, September 2026",
      url: "https://www.bls.gov/news.release/empsit.b.htm",
    },
    {
      title: "FactSet: September 2026 payrolls projected to rise by 90,000",
      url: "https://insight.factset.com/total-nonfarm-payrolls-for-september-2026-are-projected-to-rise-by-90000",
    },
    {
      title: "MUFG: US labour update, 1 October 2026",
      url: "https://www.mufgresearch.com/macro/us-labor-update-october-1-2026/",
    },
    {
      title:
        "Reuters Breakingviews: Junior bankers will survive the AI onslaught",
      url: "https://www.reuters.com/commentary/breakingviews/junior-bankers-will-survive-ai-onslaught-2026-06-29/",
    },
    {
      title:
        "Insurance Business: Insurance keeps losing jobs; AI is only part of the story",
      url: "https://www.insurancebusinessmag.com/us/news/breaking-news/insurance-keeps-losing-jobs--ai-is-only-part-of-the-story-589149.aspx",
    },
    {
      title:
        "Claims Journal: Entry-level adjuster hiring falls as insurers turn to AI",
      url: "https://www.claimsjournal.com/news/national/2026/08/27/339781.htm",
    },
    {
      title: "CNBC: Demand for agent-orchestration skills at banks",
      url: "https://www.cnbc.com/2026/10/02/ai-skills-most-in-demand-at-jpmorgan-chase-citigroup-capital-one.html",
    },
    {
      title: "Goldman Sachs: 2025 fourth-quarter and full-year results",
      url: "https://www.goldmansachs.com/pressroom/press-releases/current/pdfs/2025-q4-results.pdf",
    },
    {
      title: "TIME: Marco Argenti and Goldman Sachs’ AI strategy",
      url: "https://time.com/collection/executives-of-the-year-tech-data/2026/marco-argenti/",
    },
    {
      title: "Observer: Goldman Sachs AI strategy and Banker Copilot",
      url: "https://observer.com/2025/09/interview-marco-argenti-goldman-sachs-ai-strategy/",
    },
  ],
  "retailer-agent-access-policy-ai-shopping-2026": [
    {
      title:
        "The Wall Street Journal: AI Agents Aim to Change Shopping. Some Retailers Are Locking the Doors.",
      url: "https://www.wsj.com/cmo-today/ai-agents-aim-to-change-shopping-some-retailers-are-locking-the-doors-666a1ed4",
    },
    {
      title: "Shopify: Agentic Commerce: Benefits & How To Get Started",
      url: "https://www.shopify.com/blog/agentic-commerce",
    },
  ],
  "ai-agents-consumer-inertia-margin-resilience-2026": [
    {
      title:
        "Reuters: Meta’s Muse rekindles fears over winners and losers as personal AI agent emerges",
      url: "https://www.reuters.com/business/finance/metas-muse-rekindles-fears-over-winners-losers-personal-ai-agent-emerges-2026-09-23/",
    },
    {
      title:
        "CNBC: Meta’s Muse agent is attacking one of the economy’s most profitable weak spots",
      url: "https://www.cnbc.com/2026/09/27/meta-muse-ai-personal-agent.html",
    },
  ],
  "ai-agent-operational-identity-delegation-2026": [
    {
      title:
        "TechCrunch: All the AI agents that can live in your text messages",
      url: "https://techcrunch.com/2026/10/03/all-the-ai-agents-that-can-live-in-your-text-messages/",
    },
    {
      title:
        "TechCrunch: Viral AI assistant Instinct now has its own email address",
      url: "https://techcrunch.com/2026/09/09/viral-ai-assistant-instinct-now-has-its-own-email-address/",
    },
    {
      title:
        "Microsoft: Insights from the 2026 Microsoft Digital Defense Report",
      url: "https://www.microsoft.com/en-us/security/blog/2026/10/01/insights-from-the-2026-microsoft-digital-defense-report/",
    },
  ],
  "maximum-autonomous-consequence-ai-agent-governance-2026": [
    {
      title:
        "Reuters: OpenAI safety employee quits, says 'time for trial and error is over'",
      url: "https://www.reuters.com/legal/litigation/openai-safety-employee-quits-says-time-trial-error-is-over-2026-10-03/",
    },
    {
      title:
        "Microsoft: Insights from the 2026 Microsoft Digital Defense Report",
      url: "https://www.microsoft.com/en-us/security/blog/2026/10/01/insights-from-the-2026-microsoft-digital-defense-report/",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "ai-agent-employee-identity-access-revocation-2026": [
    {
      title:
        "Microsoft: Insights from the 2026 Microsoft Digital Defense Report",
      url: "https://www.microsoft.com/en-us/security/blog/2026/10/01/insights-from-the-2026-microsoft-digital-defense-report/",
    },
    {
      title: "Microsoft: 2026 Digital Defense Report",
      url: "https://www.microsoft.com/en-us/security/security-insider/threat-landscape/2026-digital-defense-report",
    },
    {
      title: "NIST: AI Risk Management Framework",
      url: "https://www.nist.gov/itl/ai-risk-management-framework",
    },
  ],
  "uk-ai-marketing-agency-who-does-the-work-who-signs": [
    {
      title: "UK Government: Artificial Intelligence Playbook",
      url: "https://www.gov.uk/government/publications/ai-playbook-for-the-uk-government/artificial-intelligence-playbook-for-the-uk-government-html",
    },
    {
      title: "ICO: AI governance and accountability toolkit",
      url: "https://ico.org.uk/for-organisations/advice-and-services/audits/data-protection-audit-framework/toolkits/artificial-intelligence/governance-and-accountability-in-ai/",
    },
    {
      title: "ASA: Disclosure of AI in advertising",
      url: "https://www.asa.org.uk/news/disclosure-of-ai-in-advertising-striking-the-balance-between-creativity-and-responsibility.html",
    },
  ],
  "what-uk-b2b-companies-should-buy-from-an-ai-marketing-agency": [
    {
      title: "IPA: Les Binet and Peter Field effectiveness research",
      url: "https://ipa.co.uk/knowledge/effectiveness-research-analysis/les-binet-peter-field",
    },
    {
      title: "LinkedIn B2B Institute: The 95\u20135 rule",
      url: "https://business.linkedin.com/advertise/resources/b2b-institute/b2b-research/trends/95-5-rule",
    },
    {
      title: "ICO: AI and data protection guidance",
      url: "https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/artificial-intelligence/",
    },
  ],
  "first-90-days-uk-aeo-programme-what-you-get": [
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title:
        "Google Search Central: Creating helpful, reliable, people-first content",
      url: "https://developers.google.com/search/docs/fundamentals/creating-helpful-content",
    },
    {
      title: "UK Government: AI Playbook PDF",
      url: "https://assets.publishing.service.gov.uk/media/67aca2f7e400ae62338324bd/AI_Playbook_for_the_UK_Government__12_02_.pdf",
    },
  ],
  "ai-visibility-check-vs-vanity-score-uk-b2b": [
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title: "Google Search Help: About AI features in Search",
      url: "https://support.google.com/websearch/answer/14901683?hl=en",
    },
    {
      title: "UK Government: Introduction to AI assurance",
      url: "https://www.gov.uk/government/publications/introduction-to-ai-assurance/introduction-to-ai-assurance",
    },
  ],
  "is-aeo-a-new-channel-or-one-seo-job": [
  {
    "title": "Google: Optimizing your website for generative AI features on Google Search",
    "url": "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide"
  },
  {
    "title": "Bing Webmaster Guidelines",
    "url": "https://www.bing.com/webmasters/help/webmaster-guidelines-30fba23a"
  },
  {
    "title": "Google Search Console: Generative AI performance report Search",
    "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
  }
],
  "organic-rank-is-not-ai-citation": [
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
    {
      title: "Bing Webmaster Tools: AI performance",
      url: "https://www.bing.com/webmasters/help/ai-performance-9f8e7d6c",
    },
  ],  "is-universal-geo-strategy-dead-engine-specific-authority": [
    {
      title: "Howseen AI: Google’s AI cites YouTube in 45% of answers",
      url: "https://howseen.ai/data/youtube-reddit-ai-answers",
    },
    {
      title: "Google Search Central: AI features and your website",
      url: "https://developers.google.com/search/docs/appearance/ai-features",
    },
  ],
  "is-zero-risk-ai-zero-value-consequence-budgets": [
    {
      title: "Reuters: OpenAI’s Altman says AI benefits warrant accepting some risks",
      url: "https://www.reuters.com/business/openais-altman-says-ai-benefits-warrant-accepting-some-risks-2026-10-04/",
    },
  ],
  "nvidia-saudi-arabic-nemotron-35-asr-sada-dataset-2026": [
    {
      title: "NVIDIA Developer: Fine-tuning Nemotron for Saudi Arabic dialects",
      url: "https://developer.nvidia.com/blog/fine-tuning-nvidia-nemotron-for-saudi-arabic-dialects-with-a-path-to-other-languages/",
    },
    {
      title: "Saudi Press Agency: NVIDIA leverages SDAIA’s SADA dataset",
      url: "https://www.spa.gov.sa/N2691896",
    },
  ],

  "chatgpt-ads-visual-format-measurement-reasoned-intent-2026": [
      { title: "OpenAI: Building advertising for the way people use AI", url: "https://openai.com/index/new-chatgpt-ads-format-and-measurement/" },
      { title: "OpenAI Ads Blog: More ways to measure ChatGPT Ads", url: "https://ads.openai.com/blog/more-ways-to-measure" },
  ],
  "agentic-traffic-demand-visibility-agent-experience-2026": [
      { title: "HUMAN Security: State of Agentic Traffic, September 2026", url: "https://www.humansecurity.com/learn/blog/september-2026-agentic-traffic-triples-meta-muse-debuts-at-no-1/" },
  ],
  "enterprise-ai-agents-knowledge-context-production-2026": [
      { title: "MIT Technology Review Insights: Connecting AI agents to enterprise knowledge", url: "https://www.technologyreview.com/2026/10/05/1145580/connecting-ai-agents-to-enterprise-knowledge/" },
      { title: "Neo4j: Data isn’t enough: What AI agents need to reach production", url: "https://neo4j.com/whitepapers/mit-knowledge-layer/" },
  ],
  "chatgpt-ads-vs-agentic-demand-attribution-2026": [
    {
      title: "OpenAI Ads: More ways to measure ChatGPT Ads",
      url: "https://ads.openai.com/blog/more-ways-to-measure",
    },
    {
      title: "OpenAI: Building advertising for the way people use AI",
      url: "https://openai.com/index/new-chatgpt-ads-format-and-measurement/",
    },
    {
      title: "HUMAN Security: State of Agentic Traffic, April 2026",
      url: "https://www.humansecurity.com/learn/blog/state-of-agentic-traffic-april-26/",
    },
    {
      title: "Cloudflare: The Internet has a second audience",
      url: "https://blog.cloudflare.com/agentic-web/",
    },
  ],
  "openai-openads-optimizer-testflight-warning-2026": [
    {
      title: "OpenAI Ads: Advertise in ChatGPT",
      url: "https://ads.openai.com/",
    },
    {
      title: "Apple: TestFlight Overview",
      url: "https://developer.apple.com/help/app-store-connect/test-a-beta-version/testflight-overview/",
    },
    {
      title: "Apple: Recognize and avoid social engineering schemes",
      url: "https://support.apple.com/en-us/102568",
    },
    {
      title: "NCSC: Report a scam email",
      url: "https://www.ncsc.gov.uk/collection/phishing-scams/report-scam-email",
    },
    {
      title: "Apple TestFlight Terms and Conditions",
      url: "https://www.apple.com/legal/internet-services/itunes/testflight/sren/terms.html",
    },
  ],
  "securing-testflight-oauth-ai-app-impersonation-2026": [
    {
      title: "Apple: TestFlight Overview",
      url: "https://developer.apple.com/help/app-store-connect/test-a-beta-version/testflight-overview/",
    },
    {
      title: "Apple: Stop testing a build",
      url: "https://developer.apple.com/help/app-store-connect/test-a-beta-version/stop-testing-a-build/",
    },
    {
      title: "RFC 9700: OAuth 2.0 Security Best Current Practice",
      url: "https://www.rfc-editor.org/rfc/rfc9700.html",
    },
    {
      title: "Microsoft Entra: Protect against consent phishing",
      url: "https://learn.microsoft.com/en-us/entra/identity/enterprise-apps/protect-against-consent-phishing",
    },
    {
      title: "Apple: Recognize and avoid social engineering schemes",
      url: "https://support.apple.com/en-us/102568",
    },
  ],
  "radisson-chatgpt-decision-ready-demand-2026": [
    {
      title: "OpenAI: Radisson Hotel Group brings hotel discovery into ChatGPT",
      url: "https://openai.com/index/radisson/",
    },
    {
      title: "OpenAI Ads: Advertise in ChatGPT",
      url: "https://ads.openai.com/",
    },
  ],
  "gpt6-intelligent-ui-generative-experience-2026": [
    {
      title: "OpenAI: GPT-6 and Intelligent UI for everyone",
      url: "https://openai.com/index/gpt-6-for-everyone/",
    },
    {
      title: "OpenAI Help Center: ChatGPT release notes",
      url: "https://help.openai.com/en/articles/6825453-chatgpt-release-notes",
    },
  ],


  "google-ai-shopping-agents-decision-friction-2026": [
    {
      title: "Google Cloud: Gemini at Work 2026",
      url: "https://cloud.google.com/blog/products/ai-machine-learning/welcome-to-gemini-at-work-2026",
    },
    {
      title: "Google Cloud: Ulta Beauty Gemini shopping experiences",
      url: "https://www.googlecloudpresscorner.com/2026-04-22-Ulta-Beauty-and-Google-Introduce-Gemini-Enabled-Shopping-Experiences-That-Streamline-Beauty-Discovery-and-Purchase",
    },
  ],
  "ai-seo-evidence-gate-agentic-diagnosis-2026": [
    {
      title: "iPullRank: WARRANT-SEO benchmark study",
      url: "https://ipullrank.com/warrant-seo-benchmark-study",
    },
    {
      title: "iPullRank: WARRANT-SEO leaderboard",
      url: "https://ipullrank.com/warrant-seo-benchmark",
    },
  ],
  "orbital-ai-data-centres-latency-water-safety-2026": [
    {
      title: "NASA Small Spacecraft Systems Virtual Institute: Thermal Control",
      url: "https://www.nasa.gov/smallsat-institute/sst-soa/thermal-control/",
    },
    {
      title: "ESA: Space-based data centres",
      url: "https://www.esa.int/Enabling_Support/Preparing_for_the_Future/Discovery_and_Preparation/Knowledge_beyond_our_planet_space-based_data_centres",
    },
    {
      title: "International Energy Agency: Energy and AI",
      url: "https://www.iea.org/reports/energy-and-ai/energy-demand-from-ai",
    },
    {
      title: "Environmental Law Institute: Data Centers and Water Fact Sheet",
      url: "https://www.eli.org/sites/default/files/files-pdf/Data%20Centers%20and%20Water%20Fact%20Sheet%20ELI%20January%202026%20%281%29.pdf",
    },
    {
      title: "SpaceX Investor Relations: Stock information",
      url: "https://ir.spacex.com/stock-information/default.aspx",
    },
  ],
  "spacex-amazon-leo-spectrum-hybrid-network-2026": [
    {
      title: "Grain Management: definitive agreement to sell nationwide 800 MHz portfolio to SpaceX",
      url: "https://www.prnewswire.com/news-releases/grain-management-announces-definitive-agreement-to-sell-nationwide-800-mhz-spectrum-portfolio-to-spacex-302902974.html",
    },
    {
      title: "SpaceX: 8 October 2026 update and FCC narrative",
      url: "https://www.spacex.com/updates",
    },
    {
      title: "Reuters: SpaceX to acquire spectrum for Starlink mobile services",
      url: "https://www.reuters.com/business/media-telecom/spacex-acquire-spectrum-that-enables-starlink-mobile-services-2026-10-08/",
    },
    {
      title: "FCC: Supplemental Coverage from Space framework",
      url: "https://www.federalregister.gov/documents/2024/04/30/2024-06669/single-network-future-supplemental-coverage-from-space-space-innovation",
    },
    {
      title: "Amazon: how Amazon Leo builds satellites",
      url: "https://www.aboutamazon.com/stories/how-amazon-leo-builds-satellites",
    },
    {
      title: "Amazon Leo mission updates",
      url: "https://www.aboutamazon.com/news/innovation-at-amazon/project-kuiper-satellite-rocket-launch-progress-updates",
    },
    {
      title: "FCC: Kuiper Systems LLC milestone waiver order",
      url: "https://docs.fcc.gov/public/attachments/DA-26-553A1.pdf",
    },
    {
      title: "FCC: SpaceX approved for NGSO MSS direct-to-device services",
      url: "https://www.fcc.gov/document/spacex-approved-ngso-mss-system-direct-device-services",
    },
    {
      title: "Starlink Business: Starlink Mobile",
      url: "https://starlink.com/business/mobile",
    },
    {
      title: "T-Mobile: satellite phone service",
      url: "https://www.t-mobile.com/coverage/satellite-phone-service",
    },
    {
      title: "AT&T and AST SpaceMobile: definitive commercial agreement",
      url: "https://about.att.com/story/2024/ast-spacemobile-commercial-agreement.html",
    },
    {
      title: "Verizon: satellite direct-to-device relationship",
      url: "https://www.verizon.com/about/news/verizon-conquers-remaining-dead-zones-test-man-buzz-aldrin",
    },
    {
      title: "AST SpaceMobile: 2024 Form 10-K",
      url: "https://www.sec.gov/Archives/edgar/data/1780312/000095017025030909/asts-20241231.htm",
    },
    {
      title: "Amazon Leo: strategic maritime service agreements",
      url: "https://press.aboutamazon.com/amazon-leo/2026/2/amazons-satellite-internet-comes-to-maritime-customers-through-strategic-agreements",
    },
    {
      title: "SEC EDGAR: Space Exploration Technologies Corp.",
      url: "https://www.sec.gov/edgar/browse/?CIK=0001181412",
    },
    {
      title: "Nasdaq: Space Exploration Technologies Corp. Class A Common Stock (SPCX)",
      url: "https://www.nasdaq.com/market-activity/stocks/spcx",
    },
  ],
  "gulf-sovereign-ai-series-humain-g42-helix-qai-2026": [
    {
      title: "PIF: HRH Crown Prince launches HUMAIN as a global AI powerhouse",
      url: "https://www.pif.gov.sa/en/news-and-insights/press-releases/2025/hrh-crown-prince-launches-humain-as-global-ai-powerhouse/",
    },
    {
      title: "Microsoft: investment in G42 to accelerate AI development and global expansion",
      url: "https://news.microsoft.com/source/2024/04/16/microsoft-invests-1-5-billion-in-abu-dhabis-g42-to-accelerate-ai-development-and-global-expansion/",
    },
    {
      title: "MGX: final close of MGX Fund I at $49 billion in total commitments",
      url: "https://www.mgx.ae/news-insights/mgx-pleased-confirm-final-close-mgx-fund-i-49-billion-total-commitments-significantly",
    },
    {
      title: "KKR: launches Helix Digital Infrastructure",
      url: "https://www.businesswire.com/news/home/20260610500794/en/KKR-Launches-Helix-Digital-Infrastructure-a-New-Company-to-Finance-and-Deliver-the-Next-Generation-of-AI-Infrastructure",
    },
    {
      title: "Qatar Government Communications Office: Qatar launches Qai",
      url: "https://www.gco.gov.qa/en/media-centre/top-news/qatar-launches-qai-to-power-its-global-ai-ambitions/",
    },
    {
      title: "QIA: Brookfield and Qai form a $20 billion AI infrastructure partnership",
      url: "https://www.qia.qa/en/Newsroom/Pages/Brookfield-and-Qai-Form-$20-Billion-Strategic-Investment-Partnership-for-AI-Infrastructure.aspx",
    },
  ],
  "spacex-nvidia-ai-infrastructure-financing-2026": [
    { title: "Reuters: SpaceX seeks $40 billion financing to buy Nvidia chips", url: "https://www.reuters.com/business/media-telecom/spacex-seeks-40-billion-buy-nvidia-chips-ft-reports-2026-10-06/" },
    { title: "SpaceX Investor Relations: Closing of Initial Public Offering", url: "https://ir.spacex.com/updates/releases-details/2026/Space-Exploration-Technologies-Corp--Announces-Closing-of-Initial-Public-Offering-Including-Full-Exercise-of-Underwriters-Option-to-Purchase-Additional-Shares-2026-RgoR-Y1Vwh/default.aspx" },
  ],
  "ast-spacemobile-bluebird-satellite-analyst-rating-2026": [
    { title: "AST SpaceMobile: Next-Generation BlueBird", url: "https://ast-science.com/next-gen-bluebird/" },
    { title: "AST SpaceMobile: BlueBirds 14, 15 and 16 company update", url: "https://www.facebook.com/ASTSpaceMobile/posts/bluebirds-14-15-and-16-have-arrived-in-cape-canaveralback-in-texas-satellite-bui/1481512084035753/" },
    { title: "Investing.com / Reuters: AST SpaceMobile upgraded to Buy at Deutsche Bank", url: "https://www.investing.com/news/stock-market-news/ast-spacemobile-upgraded-to-buy-at-deutsche-bank-as-selloff-called-misread-4944184" },
  ],
  "aurora-autonomous-trucking-fmcsa-warning-beacon-exemption-2026": [
    { title: "FMCSA: Grant of Application for Exemption From Aurora Operations, Inc.", url: "https://www.fmcsa.dot.gov/safety/carrier-safety/grant-application-exemption-aurora-operations-inc" },
    { title: "FreightWaves: AV truck fleets win five-year exemption on warning beacons", url: "https://www.freightwaves.com/news/fmcsa-aurora-warning-beacon-exemption-five-year" },
  ],
  "nvidia-open-ai-factory-standards-ocp-2026": [
    { title: "NVIDIA: OCP Global Summit update on open AI-factory facility standards", url: "https://blogs.nvidia.com/blog/ocp-global-summit-vera-rubin-scale-ai-factories/" },
    { title: "Open Compute Project", url: "https://www.opencompute.org/" },
  ],
  "gemini-4-argon-ai-mode-comparative-evidence-2026": [
    {
      title: "Google: Gemini 4 Argon: our next era of frontier intelligence",
      url: "https://blog.google/innovation-and-ai/models-and-research/gemini-models/gemini-4-argon/",
    },
    {
      title: "Reuters: Google launches Gemini 4 Argon to developers and businesses",
      url: "https://www.reuters.com/business/google-launches-flagship-ai-model-gemini-4-argon-developers-businesses-2026-10-13/",
    },
  ],
  "google-tag-manager-optimised-containers-measurement-2026": [
    {
      title: "Google Tag Manager Help: Updates to Google tag and Google Tag Manager",
      url: "https://support.google.com/tagmanager/answer/17079602?hl=en",
    },
    {
      title: "Google Tag Manager Help: Manage tagging behavior using the container ID",
      url: "https://support.google.com/tagmanager/answer/17070049",
    },
  ],
  "openai-recording-device-security-case-2026": [
    {
      title: "US Department of Justice: Saudi National Arrested for Installing Surreptitious Audio Recording Device at OpenAI",
      url: "https://www.justice.gov/opa/pr/saudi-national-arrested-installing-surreptitious-audio-recording-device-openai",
    },
    {
      title: "Reuters: FBI arrests former OpenAI employee over alleged listening device",
      url: "https://www.reuters.com/world/us/fbi-arrests-former-openai-employee-planting-listening-device-2026-10-13/",
    },
    {
      title: "Sky News: Saudi national charged with allegedly installing a hidden recording device at OpenAI",
      url: "https://news.sky.com/story/saudi-national-charged-with-allegedly-installing-a-hidden-recording-device-at-openai-13598276",
    },
  ],
  "aeo-agency-vs-in-house-vs-hybrid-b2b-decision-guide-2026": [
  {
    "title": "Google Search Central: Do you need an SEO?",
    "url": "https://developers.google.com/search/docs/fundamentals/do-i-need-seo"
  },
  {
    "title": "Google Search Central: Optimizing for generative AI features",
    "url": "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide"
  },
  {
    "title": "Google Search Central: Third-party SEO tools, services and advice",
    "url": "https://developers.google.com/search/docs/fundamentals/third-party-seo"
  }
],
  "aeo-agency-what-to-hire-for-2026": [
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/appearance/ai-features" },
    { title: "Google Search Essentials", url: "https://developers.google.com/search/docs/essentials" },
    { title: "Google Search Central: Do you need an SEO?", url: "https://developers.google.com/search/docs/fundamentals/do-i-need-seo" },
  ],
  "aeo-agency-pricing-uk-cost-roi-guide-2026": [
  {
    "title": "Google Search Central: Do you need an SEO?",
    "url": "https://developers.google.com/search/docs/fundamentals/do-i-need-seo"
  },
  {
    "title": "Google Search Central: AI features and your website",
    "url": "https://developers.google.com/search/docs/appearance/ai-features"
  },
  {
    "title": "Whitehat: Digital Marketing Services Pricing UK",
    "url": "https://whitehat-seo.co.uk/digital-services-pricing"
  },
  {
    "title": "WebFX: Monthly SEO Services",
    "url": "https://www.webfx.com/seo/services/monthly-seo/"
  }
],
  "track-ai-overview-impressions-google-search-console": [
  {
    "title": "Google’s report documentation",
    "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
  },
  {
    "title": "Google’s guidance on AI features",
    "url": "https://developers.google.com/search/docs/appearance/ai-features"
  },
  {
    "title": "current optimization guide",
    "url": "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide"
  }
],
  "how-to-measure-aeo-results-b2b-analytics-guide-2026": [
  {
    "title": "Google Search Console: Generative AI performance report — Search",
    "url": "https://support.google.com/webmasters/answer/16984139"
  },
  {
    "title": "Google Search Console: Performance report overview and basic setup",
    "url": "https://support.google.com/webmasters/answer/7576553?hl=en"
  },
  {
    "title": "Google Search Console: Common tasks and use cases",
    "url": "https://support.google.com/webmasters/answer/17010961?hl=en"
  },
  {
    "title": "Google Search Console: Dimensions and data groupings",
    "url": "https://support.google.com/webmasters/answer/17011259?hl=en"
  },
  {
    "title": "Google Search Console: Advanced filtering and comparison",
    "url": "https://support.google.com/webmasters/answer/17011165?hl=en"
  },
  {
    "title": "Google Search Console: Troubleshooting data discrepancies",
    "url": "https://support.google.com/webmasters/answer/17010575?hl=en"
  },
  {
    "title": "Google Search Console: About the Performance report data",
    "url": "https://support.google.com/webmasters/answer/17011364?hl=en"
  }
],
  "how-to-check-chatgpt-recommends-your-brand": [
  {
    "title": "Search results and citations can be incomplete, outdated, or incorrect",
    "url": "https://help.openai.com/en/articles/9237897-searching-the-web-with-chatgpt"
  },
  {
    "title": "current Temporary Chat guidance",
    "url": "https://help.openai.com/en/articles/8914046-temporary-chat-in-chatgpt"
  },
  {
    "title": "accuracy guidance",
    "url": "https://help.openai.com/en/articles/8313428-does-chatgpt-tell-the-truth"
  },
  {
    "title": "Generative AI performance documentation",
    "url": "https://support.google.com/webmasters/answer/16984139?hl=en"
  }
],
  "integrated-marketing-b2b-tech-ai-visibility-lead-generation": [
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/fundamentals/ai-optimization-guide" },
    { title: "UK CAP Code: Recognition of marketing communications", url: "https://www.asa.org.uk/type/non_broadcast/code_section/02.html" },
    { title: "Google Ads: About Conversion Lift", url: "https://support.google.com/google-ads/answer/12003020?hl=en" },
  ],
  "ai-marketing-thin-evidence-human-review": [
    { title: "NIST AI Risk Management Framework 1.0", url: "https://nvlpubs.nist.gov/nistpubs/ai/nist.ai.100-1.pdf" },
    { title: "Google Ads Help: Manage auto-apply recommendations", url: "https://support.google.com/google-ads/answer/10276359?hl=en" },
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/appearance/ai-features" },
    { title: "EU AI Act Service Desk: Article 14 — Human oversight", url: "https://ai-act-service-desk.ec.europa.eu/en/ai-act/article-14" }
  ],
  "aeo-citation-panel-operating-sheet-b2b-2026": [
    { title: "Bing Webmaster Tools: AI Performance", url: "https://www.bing.com/webmasters/help/ai-performance-9f8e7d6c" },
    { title: "Microsoft Bing: Introducing Topics Portfolio Beta", url: "https://blogs.bing.com/webmaster/2026/10/introducing-topics-portfolio-beta-in-ai-performance/" },
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/appearance/ai-features" },
    { title: "Google Search Central: Generative AI performance reports", url: "https://developers.google.com/search/blog/2026/06/gen-ai-performance-reports" },
    { title: "Google Search Console: Performance report overview", url: "https://support.google.com/webmasters/answer/7576553?hl=en" },
  ],
  "aeo-2026-complete-guide-answer-engine-optimisation-b2b": [
    { title: "Google Search Central: AI features and your website", url: "https://developers.google.com/search/docs/appearance/ai-features" },
    { title: "Google Search Central: Introduction to robots.txt", url: "https://developers.google.com/search/docs/crawling-indexing/robots/intro" },
    { title: "Google Search Central: Article structured data", url: "https://developers.google.com/search/docs/appearance/structured-data/article" },
    { title: "Google Search documentation updates", url: "https://developers.google.com/search/updates" },
  ],
};

export function getArticleSourceContext(slug: string): ArticleSource[] {
  return ARTICLE_SOURCE_CONTEXT[slug] ?? [];
}

export function combineSourceContext(
  ...groups: ArticleSource[][]
): ArticleSource[] {
  const sources: ArticleSource[] = [];
  for (const group of groups) {
    for (const source of group) {
      if (!sources.some(existing => existing.url === source.url)) {
        sources.push(source);
      }
    }
  }
  return sources;
}
